import CrudAPI from '@/api/resources/crud'

const permissionsAPI = {
  // specific permissions api
  loadPermissions () {
    return new Promise((resolve, reject) => {
      let permissions = CrudAPI.dfsResourceIndex('permissions')

      permissions.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  }
}

export default permissionsAPI



// WEBPACK FOOTER //
// ./src/api/resources/permissions.js